import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import * as fromToast from './toast.reducers';
import * as fromClients from './users.reducers';
import * as fromCities from './city.reducers';
import * as fromFilials from './filial.reducers';
import * as fromConverter from './converter.reducers';

export interface State {
  toastMessages: fromToast.State;
  cities: fromCities.State;
  converter: fromConverter.State;
  users: fromClients.State;
  filials: fromFilials.State;
}

export const reducers: ActionReducerMap<State, any> = {
  toastMessages: fromToast.reducer,
  cities: fromCities.reducer,
  users: fromClients.reducer,
  converter: fromConverter.reducer,
  filials: fromFilials.reducer,
};

export const selectSharedFeatureState = createFeatureSelector<State>('shared');
